// extracted by mini-css-extract-plugin
module.exports = {"list":"Spendings_list__1d3Uq","title":"Spendings_title__3eD6B","wrapperTwoP":"Spendings_wrapperTwoP__2NIje"};